export default __webpack_public_path__ + "static/media/e3.bfd8af49.webp";